import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_holidays_valentines: FaireCategoryEntity = {
  token: "cat_holidays-valentines",
  type: "category",
  name: "Valentine's Day",
  level: 2,
  parentToken: "cat_holidays-seasonal",
  href: "/category/valentines",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
